"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Subtitle = exports.Container = exports.Code = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Code = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n  color      : ", ";\n  font-size  : 16px;\n  text-align : center;\n"])), _widths.font.semi, function (_ref) {
  var color = _ref.color;
  return color;
});

exports.Code = Code;

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius   : ", "px;\n  max-width       : 408px;\n  min-height      : 200px;\n  width           : 100%;\n  background-image: linear-gradient(291deg, ", ", ", ");\n  text-align      : center;\n  display         : flex;\n  align-items     : center;\n  justify-content : center;\n  flex-direction  : column;\n  padding         : 0 ", "px;\n\n  ", " {\n    max-width: 456px;\n  }\n"])), _widths.widths.base, _palette.palette.secondary, _palette.palette.secondaryDegradate, _widths.widths.base * 2, _widths.mediaQueries.desktopWidth);

exports.Container = Container;

var Subtitle = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight  : ", ";\n  color        : ", ";\n  font-size    : 12px;\n  text-align   : center;\n  margin-top   :  ", "px;\n  margin-bottom: 2px;\n"])), _widths.font.regular, function (_ref2) {
  var color = _ref2.color;
  return color;
}, _widths.widths.base);

exports.Subtitle = Subtitle;

var Title = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n  color      : ", ";\n  font-size  : 24px;\n  text-align : center;\n  margin-top : ", "px;\n  line-height: normal;\n"])), _widths.font.semi, function (_ref3) {
  var color = _ref3.color;
  return color;
}, _widths.widths.base);

exports.Title = Title;
Container.displayName = 'Container';
Code.displayName = 'Code';
Subtitle.displayName = 'Subtitle';
Title.displayName = 'Title';